import { create } from 'apisauce';
// eslint-disable-next-line no-unused-vars
import store from '~store';
// eslint-disable-next-line no-unused-vars
import router from '~router';

const $api = create({
    baseURL: process.env.VUE_APP_API_HOST,
    headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
    },
    withCredentials: true,
    timeout: 70000,
});

$api.axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (401 === error.response.status) {
            store.dispatch('auth/logout');

            if (router.currentRoute.name !== 'auth.login') {
                router.push({ name: 'auth.login' });
            }

            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

export default $api;
